import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";
import type { Role } from "../services/auth.service";

/**
 * Guarda de papel (visual). A autorização real é sempre do backend —
 * aqui apenas evitamos exibir telas que o usuário não pode operar.
 */
export default function RequireRole({ roles }: { roles: Role[] }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user || !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
